const BASE_ENDPOINT =
  'https://ae-cp-static-files.s3.eu-central-1.amazonaws.com';

export const internalTestTaskFileUrl = (filename: string) =>
  `${BASE_ENDPOINT}/internal_tt_attachments/${filename}`;

export const videoFileUrl = (filename: string) =>
  `${BASE_ENDPOINT}/intro-video/${filename}`;

export const aeImageLogoUrl = `${BASE_ENDPOINT}/emails/ae-logo-bg.png`;
export const aeTeamImageUrl = `${BASE_ENDPOINT}/emails/ae-team.png`;

export const guaranteeUserIcon = `${BASE_ENDPOINT}/projects-images/guarantee-user-icon.png`;
export const cloclIcon = `${BASE_ENDPOINT}/projects-images/clock-icon.png`;
export const dollarsImgURL = `${BASE_ENDPOINT}/projects-images/dollars.png`;
export const hotAirBalloonImgURL = `${BASE_ENDPOINT}/projects-images/hotAirBalloon.png`;
export const newFolderImgURL = `${BASE_ENDPOINT}/projects-images/newFolder.png`;
export const hiFiveImgURL = `${BASE_ENDPOINT}/projects-images/hiFive.png`;
